export default __webpack_public_path__ + "static/media/AE15.7cbd0a50.jpg";